var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello",style:({position:_vm.fliex,left:_vm.clientX-400+'px',top:_vm.clientY+20+'px'})},[_c('div',{attrs:{"id":"orderTime"}})])}
var staticRenderFns = []

export { render, staticRenderFns }